<template>
    <a class="category__produkt--bilder" :href="itemUrl" :title="titleText">
        <div
            class="category__produkt--bilder-container"
            @mouseover="twoImages.length > 1 ? setupHover($event, true) : null"
            @mouseleave="
                twoImages.length > 1 ? setupHover($event, false) : null
            "
            v-if="lazyImages"
        >
            <lazy-category-img
                v-for="(imageUrl, index) in twoImages"
                :key="index"
                :imageUrl="imageUrl.url"
                :alt="getAltText(imageUrl)"
                :title="getAltText(imageUrl)"
                :class="[onHover ? 'active' : '', 'img-fluid']"
            />
        </div>

        <div
            class="category__produkt--bilder-container"
            @mouseover="twoImages.length > 1 ? setupHover($event, true) : null"
            @mouseleave="
                twoImages.length > 1 ? setupHover($event, false) : null
            "
            v-else
        >
            <img
                v-for="(imageUrl, index) in twoImages"
                :key="index"
                :src="imageUrl.url"
                :alt="getAltText(imageUrl)"
                :title="getAltText(imageUrl)"
                :class="[onHover ? 'active' : '', 'img-fluid']"
            />
        </div>
    </a>
</template>

<script>
export default {
    name: "item-images",

    props: {
        lazyImages: {
            type: Boolean,
            required: false
        },

        imageUrlsData: {
            type: Array
        },
        itemUrl: {
            type: String
        },
        altText: {
            type: String
        },
        titleText: {
            type: String
        }
    },

    data() {
        return {
            onHover: false,
            id: null
        };
    },

    computed: {
        imageUrls() {
            return this.imageUrlsData.sort((imageUrlA, imageUrlB) => {
                if (imageUrlA.position > imageUrlB.position) {
                    return 1;
                }
                if (imageUrlA.position < imageUrlB.position) {
                    return -1;
                }

                return 0;
            });
        },

        twoImages() {
            if (!this.imageUrls) {
                return;
            }

            return this.imageUrls.filter((img, i) => i <= 1);
        }
    },

    methods: {
        getAltText(image) {
            const altText =
                image && image.alternate ? image.alternate : this.altText;

            return altText;
        },

        getImageName(image) {
            const altText = image && image.name ? image.name : this.titleText;

            return altText;
        },

        setupHover(event, show) {
            // get tallest image
            const tallestImageSizes = [...event.currentTarget.children].reduce(
                (previous, current) => {
                    if (previous.height) {
                        previous.height =
                            previous.height >= current.height
                                ? previous.height
                                : current.height;
                    }

                    if (previous.width) {
                        previous.width =
                            previous.width >= current.width
                                ? previous.width
                                : current.width;
                    }

                    if (previous.height) {
                        return previous;
                    }

                    return {
                        width: current.offsetWidth,
                        height: current.offsetHeight
                    };
                },
                {}
            );

            event.currentTarget.style.height = tallestImageSizes.height + "px";
            event.currentTarget.style.width = tallestImageSizes.width + "px";

            this.onHover = show;
        }
    }
};
</script>
